import {get} from 'lodash';

class PersonDetails {
    constructor($filter) {

        this.$onInit = () => {

            const phoneType = get(this, 'contactModel.primaryPhoneType.value.code');

            this.phoneLabels = {
                home: $filter('translate')(`gateway.contacts.components.ContactDetailsPerson.home${phoneType === 'home' ? ' primary' : ''}`),
                work: $filter('translate')(`gateway.contacts.components.ContactDetailsPerson.work${phoneType === 'work' ? ' primary' : ''}`),
                mobile: $filter('translate')(`gateway.contacts.components.ContactDetailsPerson.mobile${phoneType === 'mobile' ? ' primary' : ''}`),
            };

        };

    }
}

PersonDetails.$inject = ['$filter'];

export default PersonDetails;
